module.exports = __webpack_public_path__ + "3096d2a79e6d86805d87238c24225bac.pdf";